import * as eventTypes from '../eventTypes'
import * as actionTypes from '../actionTypes'

const events = {}

// Media devices have changed.
events[actionTypes.DEVICES_CHANGE] = action => {
  return {
    type: eventTypes.DEVICES_CHANGED
  }
}

events[actionTypes.INITIALIZE_DEVICES_FINISH] = action => {
  if (action.error) {
    return {
      type: eventTypes.INITIALIZE_DEVICES_ERROR,
      args: { error: action.payload }
    }
  } else {
    return {
      type: eventTypes.DEVICES_CHANGED
    }
  }
}

export default events
